import React from 'react';
import { Navigate, useNavigate, useBlocker } from 'react-router-dom';
import { store } from 'Models/Store';
import { checkPaymentNotTaken } from 'Services/Api/_HumanWritten/PaymentService';
import { onWizardSuccess } from 'Util/_HumanWritten/BookingWizard/BookingWizardUtils';
import { isNullOrUndefined } from 'Util/TypeGuards';
import { getBookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardDataStore';
import { PostPaymentRender } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/PostPayment/PostPaymentRender';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import { Flex } from 'Views/Components/Flex/Flex';
import { SecuredGroups } from 'Models/Security/UserGroups';
import { getFerryBookingTransactionIdFromStorage } from 'Services/Api/_HumanWritten/BookingService/BookingService';

/* 15 seconds */
export const AWAITING_PAYMENT_TIMEOUT = 15000;

/* 1 second */
export const AWAITING_PAYMENT_INTERVAL = 1000;

export default function AwaitEwayPaymentPage() {
	const navigate = useNavigate();

	const bookingWizardData = getBookingWizardData(null);
	const transactionId = getFerryBookingTransactionIdFromStorage();
	const loading = React.useRef(false);
	const timeout = React.useRef<any>();
	const interval = React.useRef<any>();
	const [shouldBlock, setShouldBlock] = React.useState(true);

	const cleanUp = () => {
		clearTimeout(timeout.current);
		clearInterval(interval.current);
		setShouldBlock(false);
		store.modal.hide();
	};

	const handleTimeout = () => {
		cleanUp();
		navigate('/booking-wizard/payment?ErrorCode=AwaitingPaymentTimeout', { replace: true });
	};

	const checkPayment = async () => {
		if (loading.current || isNullOrUndefined(transactionId) || isNullOrUndefined(bookingWizardData)) {
			// We don't want to do the request until the previous request is complete
			return;
		}

		loading.current = true;

		try {
			const res = await checkPaymentNotTaken(transactionId);
			if (!res.data) {
				cleanUp();
				onWizardSuccess(
					navigate,
					transactionId,
					bookingWizardData.wizardMode === 'ALTERATION',
					bookingWizardData.returningTicketId !== '',
					// TODO: events payments
					false,
					bookingWizardData.userId,
				);
			} else {
				loading.current = false;
			}
		} catch {
			cleanUp();
			navigate('/booking-wizard/reservation', { replace: true });
		}
	};

	const beforeUnload = (event: BeforeUnloadEvent) => {
		if (!shouldBlock) return;

		event.preventDefault();
		event.returnValue = '';
	};

	// TODO JARRAH -  Need to fix the blocker functionality
	// // Use React Router v6's useBlocker
	// const blocker = useBlocker(
	// 	({ currentLocation, nextLocation }) => shouldBlock && currentLocation.pathname !== nextLocation.pathname,
	// );

	// // Handle blocked navigation
	// React.useEffect(() => {
	// 	if (blocker.state === 'blocked') {
	// 		newConfirmModal('Leaving page?', 'Are you sure you want to leave?')
	// 			.then(() => {
	// 				setShouldBlock(false);
	// 				// Small delay to ensure shouldBlock state updates before proceeding
	// 				setTimeout(() => blocker.proceed(), 0);
	// 			})
	// 			.catch(() => {
	// 				blocker.reset();
	// 			});
	// 	}
	// }, [blocker]);

	// Setup timers and beforeunload listener
	React.useEffect(() => {
		timeout.current = setTimeout(handleTimeout, AWAITING_PAYMENT_TIMEOUT);
		interval.current = setInterval(checkPayment, AWAITING_PAYMENT_INTERVAL);

		window.addEventListener('beforeunload', beforeUnload);

		return () => {
			cleanUp();
			window.removeEventListener('beforeunload', beforeUnload);
		};
	}, []);

	if (isNullOrUndefined(transactionId) || isNullOrUndefined(bookingWizardData)) {
		return <Navigate to="/home" replace />;
	}

	return (
		<SecuredPage groups={SecuredGroups.create.onlyLoggedIn().groups}>
			<div className="body-content">
				<Flex className="height-100" justify="center" align="center">
					<PostPaymentRender />
				</Flex>
			</div>
		</SecuredPage>
	);
}
